import { Grid, SxProps, Theme, Typography } from "@mui/material";
import {
	flexCenterProps,
	titleContextProps,
} from "@styles/global-css-class";
import { memo } from "react";

const TitleForm = ({ title, sxTheme }: { title: string, sxTheme?: SxProps<Theme> }) => {
	return (
		<Grid container item sx={sxTheme ?? {
			...flexCenterProps,
			pb: 1,
			px: "8px"
		}}>
			<Typography sx={titleContextProps}>{title}</Typography>
		</Grid>
	);
};

export default memo(TitleForm);
